import { getFetchManyProductsUrl } from './get-fetch-many-products-url';
import { getFetchUrl } from './get-fetch-url';
/**
 * @internal
 */
export var getFetchManyEntitiesUrl = function (entityIds, productType, includeType) {
    if (productType === "p" /* Product */) {
        return getFetchManyProductsUrl(entityIds, includeType);
    }
    else {
        return getFetchUrl(entityIds, productType, includeType);
    }
};
